<template>
  <div
      class="learn-more"
  >
    <div
        @click="scrollTo"
        :class="{leftTable: moveLeftOnTablet}"
        class="content is-clickable has-text-centered"
    >
      <span>Learn More</span><br/>
      <chevron-down-icon size="1.2x"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.learn-more {
  position: absolute;
  bottom: 1rem;
  width: 100%;
  z-index: 7;

  .content {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 7.5rem;
    padding: 1rem;
    border-radius: 5px;


    @media screen and (max-width: $widescreen) {
      margin-left: 10%;
    }

    ::v-deep svg {
      margin-top: .5rem;
      transition: all 400ms;
    }

    &:hover {
      ::v-deep svg {
        margin-top: 1rem;
      }
    }
  }
}
</style>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChevronDownIcon } from 'vue-feather-icons';

@Component({
  components: {
    ChevronDownIcon
  }
})
export default class MScrollDown extends Vue {
  @Prop({ required: true })
  scrollToCssSelector!: string;

  scrollTo () {
    // @ts-ignore
    document.querySelector(this.scrollToCssSelector).scrollIntoView({
      behavior: 'smooth'
    });
  }
}
</script>
